/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { alpha, Theme } from "@mui/material";

export const ourServiceStyle = {
  tabsList: (theme: Theme) => ({
    gap: "0.5rem",
    [theme.breakpoints.up("md")]: {
      gap: "1.5rem",
    },
  }),
  tabsIndicator: (theme: Theme) => ({
    top: 0,
    backgroundColor: theme.palette.secondary.main,
    height: "2px",
  }),
  tab: (theme: Theme) => ({
    borderTop: `2px solid ${alpha(theme.palette.background.default, 0.3)}`,
    alignItems: "flex-start",
    textAlign: "left",
    padding: 0,
    typography: "body2",
    color: alpha(theme.palette.common.white, 0.6),
    "&.Mui-selected": {
      color: theme.palette.common.white,
    },
    minWidth: 0,
  }),
  ourService: (theme: Theme) => ({
    background: theme.palette.gradients.charcoal,
    color: theme.palette.common.white,
    paddingTop: "5rem",
    [theme.breakpoints.up("md")]: {
      paddingTop: "10rem",
    },
  }),
};
